<div class="flex content-between items-center" mat-dialog-title>
    <span> Buscador de usuarios </span>
    <button mat-icon-button (click)="onClose()">
        <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
    </button>
</div>
<mat-dialog-content>
    <ng-content></ng-content>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" mat-flat-button (click)="onClose()">
        <mat-icon class="mr-1" svgIcon="heroicons_outline:cancel_circle"></mat-icon>
        Cerrar
    </button>
    <button
        *ngIf="dialogData.multiSelect"
        type="button"
        mat-flat-button
        (click)="onSelectItems()"
        color="primary"
    >
        <mat-icon class="mr-1" svgIcon="heroicons_outline:check-circle"></mat-icon>
        Seleccionar
    </button>
</mat-dialog-actions>
